import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Paper as MuiPaper, Box as MuiBox } from "@mui/material";
import { DataGridPro as MuiDataGrid } from "@mui/x-data-grid-pro";
import { useStudies } from "app/services/studiesService";
import { LOADER_TYPES } from "app/shared/constants";
import { mapStudiesToDisplayed } from "app/shared/utils";
import { studyTableStyles } from "app/components/study/StudyTableStyles";
import { tableStyles } from "app/shared/UI/sharedStyles";
import { LoadingGridOverlay, NoRowsGridOverlay } from "common";
import { defaultTableColumnHeaders } from "./StudyTableConfig";
import { useNavigate } from "react-router-dom";

const StudyTable = () => {
  const {
    totalCount,
    pagination,
    setPagination,
    sort,
    setSort,
    isLoading,
    studies,
  } = useStudies();

  const mappedStudies = mapStudiesToDisplayed(studies);
  const [openRiskDialog, setOpenRiskDialog] = useState(false);
  const [riskDialogRow, setRiskDialogRow] = useState(-1);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [refresh, setRefresh] = useState(false);
  const [
    openOutreachFailureSummaryDialog,
    setOpenOutreachFailureSummaryDialog,
  ] = useState(false);
  const [
    outreachFailureSummaryDialogIndex,
    setOutreachFailureSummaryDialogIndex,
  ] = useState(-1);

  const displayRiskDialog = (index) => {
    setOpenRiskDialog(true);
    setRiskDialogRow(index);
  };

  const closeRiskDialog = () => {
    setOpenRiskDialog(false);
    setRiskDialogRow(-1);
  };

  const closeOutreachFailureSummary = () => {
    setOpenOutreachFailureSummaryDialog(false);
  };

  const NoStudyOverlay = () => (
    <NoRowsGridOverlay message={t(`common.emptyTableRow`)} />
  );

  const handleSortChange = (sortModel) => {
    setSort({
      orderBy: sortModel[0].field,
      order: sortModel[0].sort,
    });
  };

  const handlePaginationModelChange = (model) => {
    setPagination({
      ...pagination,
      page: model.page,
      rowsPerPage: model.pageSize,
    });
  };
  return (
    <MuiPaper sx={studyTableStyles.tableScroll}>
      <MuiBox
        id="pep-my-studies-table-box"
        sx={{ width: "100%", overflow: "auto" }}
      >
        <MuiDataGrid
          slots={{
            loadingOverlay: LoadingGridOverlay,
            noRowsOverlay: NoStudyOverlay,
          }}
          rows={mappedStudies}
          getRowId={(row) => row.id}
          columns={defaultTableColumnHeaders(
            t,
            setOpenOutreachFailureSummaryDialog,
            setOutreachFailureSummaryDialogIndex,
            openOutreachFailureSummaryDialog,
            outreachFailureSummaryDialogIndex,
            closeOutreachFailureSummary,
            displayRiskDialog,
            openRiskDialog,
            riskDialogRow,
            closeRiskDialog,
            isLoading,
            setRefresh,
            refresh,
            navigate
          )}
          autoHeight
          pagination
          disableColumnMenu
          disableColumnResize
          disableColumnReorder
          disableMultipleColumnsSorting
          disableRowSelectionOnClick
          loading={isLoading[LOADER_TYPES.STUDY_DASHBOARD_DATA]}
          paginationMode="server"
          sortingMode="server"
          pageSizeOptions={[5, 10, 25, 50, 100]}
          paginationModel={{
            page: pagination.page,
            pageSize: pagination.rowsPerPage,
          }}
          checkboxSelection
          rowCount={totalCount}
          onPaginationModelChange={handlePaginationModelChange}
          sortModel={[{ field: sort.orderBy, sort: sort.order }]}
          sortingOrder={["asc", "desc"]}
          onSortModelChange={handleSortChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd"
          }
          sx={tableStyles}
          columnHeaderHeight={90}
          getRowHeight={() => "auto"}
        />
      </MuiBox>
    </MuiPaper>
  );
};

export default StudyTable;
